import { Box, Flex, Grid, Text } from 'theme-ui'

import Image from 'next/image'
import bus10 from '~/public/images/buses/bus10.png'
import bus11 from '~/public/images/buses/bus11.png'
import bus12 from '~/public/images/buses/bus12.png'

export default function Blocks() {
  return (
    <Flex
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        pt: [4, 4, 6],
        pb: [7, 7, 9],
        px: [3, 3, 6]
      }}
    >
      <Box sx={{ maxWidth: 1230, width: '100%' }}>
        <Grid columns={['1fr', '1fr', '1fr 1fr']} sx={{ maxWidth: '100%' }}>
          <Box
            sx={{
              // backgroundImage:
              //     'linear-gradient(91.35deg, #4BF2A2 -4.66%, #A89FE7 56.06%, #E1C4F4 73.07%, #DD40CD 111.44%)',
              backgroundImage:
                'linear-gradient(315deg, #2b1331 0%, #465073 74%)',
              width: '100%',
              borderRadius: 10
            }}
          >
            <Box sx={{ padding: 4, color: 'white' }}>
              <Text
                sx={{
                  fontSize: [6, 6, 8],
                  display: 'block',
                  fontFamily: 'heading',
                  lineHeight: 1
                }}
              >
                🚌
              </Text>
              <Text
                sx={{
                  fontSize: [5, 5, 7],
                  lineHeight: 1.3,
                  fontFamily: 'heading',
                  display: 'block'
                }}
              >
                4545{' '}
                <Text as="span" sx={{ fontStyle: 'italic' }}>
                  unique
                </Text>{' '}
                Buses
              </Text>
              <Text as="p" sx={{ fontSize: [1, 1, 2], fontWeight: 300 }}>
                <ul style={{ listStyleType: 'circle' }}>
                  <li>Over 50 million prompts were generated.</li>
                  <li>
                    Of these, 15,000 were randomly selected to generate the bus
                    art.
                  </li>
                  <li>From these, 4545 were hand selected to be minted.</li>
                </ul>
              </Text>
            </Box>
            <Image
              alt="Bus"
              src={bus11}
              style={{ padding: '18px', borderRadius: '24px' }}
            />
          </Box>
          <Flex
            sx={{
              // backgroundImage:
              //     'linear-gradient(91.35deg, #4BF2A2 -4.66%, #A89FE7 56.06%, #E1C4F4 73.07%, #DD40CD 111.44%)',
              backgroundImage:
                'linear-gradient(315deg, #2b1331 0%, #465073 74%)',
              width: '100%',
              borderRadius: 10,
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                padding: 4,
                flex: 1
              }}
            >
              <Text
                sx={{
                  fontSize: [6, 6, 8],
                  display: 'block',
                  fontFamily: 'heading',
                  lineHeight: 1,
                  color: 'white'
                }}
              >
                🚍
              </Text>
              <Text
                sx={{
                  fontSize: [5, 5, 6],
                  lineHeight: 1.3,
                  fontFamily: 'heading',
                  display: 'block',
                  color: 'white'
                }}
              >
                Purchase price goes to the protocol,{' '}
                <Text as="span" sx={{ fontStyle: 'italic' }}>
                  not the devs
                </Text>{' '}
              </Text>
              <Text
                as="p"
                sx={{ fontSize: [1, 1, 2], fontWeight: 300, color: 'white' }}
              >
                The purchase price of a bus will be used to incentivize the
                growth of the protocol via the Ride the Bus Challenge. When
                people play the game, rewards are distributed back to Bus
                owners.
              </Text>
            </Box>
            <Flex
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                pt: [4, 4, 0],
                img: {
                  maxWidth: ['60%', '60%', '100%']
                }
              }}
            >
              <Image
                alt="Bus"
                src={bus12}
                style={{ padding: '18px', borderRadius: '24px' }}
              />
            </Flex>
          </Flex>
        </Grid>
        <Grid
          columns={['1fr', '1fr', '52fr 48fr']}
          gap={[0, 0, 2]}
          sx={{
            maxWidth: '100%',
            mt: 3,
            // backgroundImage:
            //     'linear-gradient(91.35deg, #4BF2A2 -4.66%, #A89FE7 56.06%, #E1C4F4 73.07%, #DD40CD 111.44%)',
            backgroundImage: 'linear-gradient(315deg, #2b1331 0%, #465073 74%)',
            width: '100%',
            borderRadius: 10
          }}
        >
          <Flex
            sx={{
              padding: 4,
              flexDirection: 'column'
            }}
          >
            <Text
              sx={{
                fontSize: [6, 6, 8],
                display: 'block',
                fontFamily: 'heading',
                lineHeight: 1,
                color: 'white'
              }}
            >
              🚐
            </Text>
            <Text
              sx={{
                fontSize: [5, 5, 8],
                lineHeight: [1.3, 1.3, 1],
                fontFamily: 'heading',
                display: 'block',
                color: 'white',
                mt: [0, 0, 3]
              }}
            >
              Protocol Earned
              <br />
              <Text as="span" sx={{ fontStyle: 'italic' }}>
                Liquidity
              </Text>{' '}
            </Text>
            <Text
              as="p"
              sx={{
                fontSize: [1, 1, 2],
                fontWeight: 300,
                maxWidth: 486,
                mt: [0, 0, 3]
              }}
            >
              Bus owners earn a share of the profit generated by the protocol.
              When the protocol profits, so do the bus owners.
            </Text>
          </Flex>
          <Box
            sx={{
              display: ['none', 'none', 'flex'],
              justifyContent: 'flex-end',
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                img: {
                  height: 'auto',
                  width: '100%',
                  display: 'block'
                }
              }}
            >
              <Image
                alt="bus10"
                src={bus10}
                style={{
                  borderRadius: '24px',
                  padding: '18px'
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: ['flex', 'flex', 'none'],
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Image alt="bus11" src={bus11} />
          </Box>
        </Grid>
      </Box>
    </Flex>
  )
}
